import { labor_cost_headers } from "@erp/shared/components/ui/Document/Labor/const";
import { printLaborCost } from "@erp/shared/components/ui/Document/Labor/utils";
import { downloadTable } from "@erp/shared/utils/excel";
import { estimatePrintOrPDF } from "@erp/shared/utils/pdf";
import { showAlert } from "@erp/shared/utils/dialog";
/**
 * @description 노무비 산출에서 쓰는 print 버튼 action 함수
 */
export function handleLaborPrint({ ref, item, excelData, }) {
    const click = item.click;
    const title = "노무비 산출";
    if (!ref)
        showAlert("선택된 노무비 산출이 없습니다.");
    if (click === "print") {
        printLaborCost(ref);
    }
    else if (click === "excel") {
        downloadTable(labor_cost_headers, excelData, title);
    }
    else if (click === "pdf") {
        printLaborCost(ref, title);
    }
}
export function handlePrintNormal({ item, pdfData, excelData, }) {
    if (item.click === "print" && !pdfData?.element) {
        return showAlert("인쇄할 내용이 없습니다.");
    }
    else if (item.click === "excel" && !excelData?.data.length) {
        return showAlert("엑셀로 다운로드할 내용이 없습니다.");
    }
    if (item.click === "print" && pdfData) {
        estimatePrintOrPDF(pdfData.itemsArr, pdfData.element, pdfData.editableItems);
    }
    else if (item.click === "excel" && excelData) {
        downloadTable(excelData.headers, excelData.data, excelData.fileName);
    }
    else if (item.click === "pdf" && pdfData) {
        estimatePrintOrPDF(pdfData.itemsArr, pdfData.element, pdfData.editableItems, pdfData.fileName);
    }
}
